import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-fish",
  "use": "icon-si-glyph-fish-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-fish\" id=\"icon-si-glyph-fish\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1135</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M12.537,7.348 C11.887,6.073 9.389,5.122 6.394,5.122 C2.908,5.122 0.0819999999,6.411 0.0819999999,8.001 C0.0819999999,9.591 2.907,10.88 6.394,10.88 C9.388,10.88 11.886,9.929 12.537,8.654 C13.196,9.495 14.49,10.845 15.974,10.845 L15.974,5.156 C14.49,5.156 13.196,6.507 12.537,7.348 L12.537,7.348 Z M2.043,8.125 L1,8.125 L1,6.917 L2.043,6.917 L2.043,8.125 L2.043,8.125 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-fish.svg
// module id = ptNi
// module chunks = 62